import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IReportCompanyUnitGroupModel, IReportCompanyUnitParamsModel } from '@apps-common/types/management/reporting'

export const getCompanyUnitsReport = async (model: IReportCompanyUnitParamsModel): Promise<IReportCompanyUnitGroupModel[]> =>
  axios.post('/management/unit/UnitsReport', model).then((res) => res.data?.data)

type Props = {
  model: IReportCompanyUnitParamsModel
}

export const useManagementGetCompanyUnitsReport = (notify?: boolean, onSuccess?: (data: IReportCompanyUnitGroupModel[]) => void) =>
  useMutation({
    mutationKey: ['getCompanyUnitsReport'],
    mutationFn: ({ model }: Props) => getCompanyUnitsReport(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Successfully fetched company devices report.')
      }
    },
    onError: (e: any) => {
      if (notify) {
        toastError(e?.message ? e?.message : 'Failed to fetch company devices report.')
      }
    },
    throwOnError: false
  })
